import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { DialogComponent } from '../dialog/dialog.component';
import { ConfirmDialogService, ConfirmOptions } from './confirm-dialog.service';

@Component({
  selector: 'confirm-dialog',
  template: `
    <dialog stDialog #dialog bgColor="white" [textCenter]="false" [disableClose]="true">
      <ng-template dialogTitle>
        <h1>{{ title | stLoc }}</h1>
      </ng-template>
      <ng-template dialogContent>
        <p>{{ message | stLoc }}</p>
      </ng-template>
      <ng-template dialogActions>
        <button type="button" class="confirm-dialog-cancel cancel" (click)="onCancel()">{{ cancelLabel | stLoc }}</button>
        <button type="button" class="confirm-dialog-confirm error" (click)="onConfirm()">{{ confirmLabel | stLoc }}</button>
      </ng-template>
    </dialog>
  `,
})
export class ConfirmDialogComponent implements AfterViewInit {
  @ViewChild('dialog', { static: false }) dialog!: DialogComponent;

  title = '';
  message = '';
  confirmLabel = 'common.yes';
  cancelLabel = 'common.cancel';

  private resolver?: (value: boolean) => void;

  constructor(private confirmService: ConfirmDialogService) { }

  ngAfterViewInit(): void {
    this.confirmService.register(this);
  }

  open(message: string, opts?: ConfirmOptions): Promise<boolean> {
    this.message = message;
    this.title = opts?.title ?? '';
    this.confirmLabel = opts?.confirmLabel ?? 'common.yes';
    this.cancelLabel = opts?.cancelLabel ?? 'common.cancel';
    this.dialog.openModal();
    return new Promise<boolean>(resolve => { this.resolver = resolve; });
  }

  onConfirm(): void {
    this.dialog.closeModal();
    this.resolve(true);
  }

  onCancel(): void {
    this.dialog.closeModal();
    this.resolve(false);
  }

  private resolve(value: boolean): void {
    this.resolver?.(value);
    this.resolver = undefined;
  }
}